export const TranslationIdMap = '';

export const TranslationKeyMap = {
};
